import { Card } from 'src/modules/shared/components/atoms/cards';
import {
  ComponentAppearance,
  ComponentVariant,
} from 'src/modules/shared/types/component.type';
import { classes } from 'src/modules/shared/utils/styles.util';

interface FunnelCardProps {
  children: React.ReactNode;
  className?: string;
  appearance?: ComponentAppearance;
  variant?: ComponentVariant;
}

export const FunnelCard = ({
  children,
  variant = 'primary',
  appearance = 'outline',
  className,
}: FunnelCardProps) => {
  const containerClasses = 'flex flex-col gap-4 px-4 py-6';

  return (
    <Card
      appearance={appearance}
      variant={variant}
      className={classes(containerClasses, className)}
    >
      {children}
    </Card>
  );
};
